module.exports = __webpack_public_path__ + "img/trunk_2x4_z18.62e4a8be.svg";